//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateProveedores } from "@/typings/store/plugins/easyFirestore/proveedores";

const getters: GetterTree<StateProveedores, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const proveedores = {
    firestorePath: "dev/v1/proveedores",
    firestoreRefType: "collection",
    moduleName: "proveedores",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default proveedores;
